import { useTranslate } from 'primary/hooks/useTranslate';
import { useCallback } from 'react';

export const useYupValidationResolver = (validationSchema: any) => {
  const t = useTranslate();
  return useCallback(
    async (data) => {
      const translatedValidationSchema =
        typeof validationSchema === 'function' ? validationSchema(t) : validationSchema;
      try {
        const values = await translatedValidationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (allErrors: any, currentError: any) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {},
          ),
        };
      }
    },
    [validationSchema],
  );
};
